import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ImportExportService } from './../../../../core/services/import-export.service';
import { AuthorizationProperties } from './../../../../authentication/auth-info';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from 'src/app/core/services/login.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { QuickNoteLevels } from 'src/app/model/ImportExportManagement';
import { DbInfoBag } from 'src/app/database/helpers/db-info-bag';
import { ExportDataBodyContent } from 'src/app/database/helpers/database-helpers';
import { MiniStorageService } from 'src/app/core/services/mini-storage.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AlertDialogComponent } from 'src/app/store/dialogs/alert-dialog/alert-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { AppSubscription } from 'src/app/model/subscription';
import { LoadingService } from 'src/app/core/services/loading.service';
import { DateAdapter } from '@angular/material/core';

export class fileDateAndName {
    fileName: string;
    dateCreat: Date;
    constructor() {}
}
@Component({
    selector: 'ms-history-imp-exp',
    templateUrl: './history-imp-exp.component.html',
    styleUrls: ['./history-imp-exp.component.scss'],
})
export class HistoryImpExpComponent implements OnInit {
    importKey: string;

    downloadFound: boolean = true;

    isLoadingExportList = false;
    logs: string;
    noteLevel: QuickNoteLevels = QuickNoteLevels.Info;
    noteTitle = 'Import data has been started';
    noteText =
        'This process has been started and it may take a few minutes to complete. You will receive a notification when the operation will be done.';
    subSelected: AppSubscription;
    subKeySelected: string;
    subDescriSelected: string;
    displayedColumnsFiles: string[] = ['FileName', 'CreationDate', 'Download'];
    authorizationStored = this.loginService.getauthinfo();
    authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);
    dbInfoBag: DbInfoBag;
    _paginatorFiles: MatPaginator;
    filesT: MatTableDataSource<fileDateAndName>;
    @ViewChild('filesPaginator') set filesPaginator(content: MatPaginator) {
        if (content) {
            // initially setter gets called with undefined
            this._paginatorFiles = content;
            const paginatorIntl = this._paginatorFiles._intl;
            paginatorIntl.nextPageLabel = this.variable.nextPage;
            paginatorIntl.previousPageLabel = this.variable.previousPage;
            if (this.filesT) {
                this.filesT.paginator = this._paginatorFiles;
            }
        }
    }
    searchText: string = null;

    localSettings: string;

    public loading: boolean = false;

    @ViewChild(MatSort, { static: false }) filesSort: MatSort;
    public mng_impexp_title: string;
    public mng_impexp_descri: string;
    public cmsObj: CmsObject[];
    language: string;

    constructor(
        private importExportService: ImportExportService,
        private loginService: LoginService,
        private variable: TranslatedVariables,
        private cmsService: CmsService,
        private workFlow: WorkFlowService,
        private miniStorage: MiniStorageService,
        private snackBar: MatSnackBar,
        private activatedRoute: ActivatedRoute,
        public loadingService: LoadingService,
        private dialog: MatDialog,
        private router: Router,

        private adapter: DateAdapter<any>
    ) {
        this.filesT = new MatTableDataSource<fileDateAndName>();
    }

    async ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (params) {
                window.history.replaceState({}, '', `/import-export-home/history-imp-exp`);
            }
            this.subKeySelected = params.subKeySelected;
        });
        this.dbInfoBag = new DbInfoBag();

        this.miniStorage.get('imp-subkey-' + this.subKeySelected).subscribe((res) => {
            if (res !== undefined) {
                this.subSelected = res;
                this.subDescriSelected = res.Description;
                const subscriptionModel = new AppSubscription();
                subscriptionModel.SubscriptionKey = res.SubscriptionKey;
                subscriptionModel.SubscriptionToken = res.SubscriptionToken;
                subscriptionModel.Description = res.Description;
                this.dbInfoBag.SubscriptionModel = subscriptionModel;
            } else this.AlertSessionExpired();
        });
        await this.getCmsObj();
        this.dbInfoBag = new DbInfoBag();
        const authorizationStored = this.loginService.getauthinfo();

        if (authorizationStored === null || authorizationStored === undefined) {
            alert('DatabaseHomeComponent: User must be logged in.');
            return;
        }
        this.authorizationProperties = JSON.parse(authorizationStored);
        // inizializzo account corrente
        this.dbInfoBag.AccountName = this.authorizationProperties.accountName;
        this.localSettings = this.authorizationProperties.regionalSettings;
        this.filesT.paginator = this.filesPaginator;
        this.filesT.sort = this.filesSort;

        this.dbInfoBag.SubscriptionKey = this.subSelected?.SubscriptionKey;

        this.getDownloadFilesList(false);
    }

    // --------------------------------------------------------------------------
    public AlertSessionExpired() {
        let quotationDialog = this.dialog.open(AlertDialogComponent, {
            data: {
                Title: this.variable.sessionExpiredTitle,
                Message: this.variable.sessionExpiredMessage,
            },
        });

        quotationDialog.afterClosed().subscribe(async () => {
            this.router.navigate(['/import-export-home']);
        });
    }

    // -----------------------------------------------------------------------------
    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'accountcomponent');
        this.mng_impexp_title = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.mng_impexp_title').ContentTranslation;
        this.mng_impexp_descri = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.mng_impexp_descri').ContentTranslation;
    }

    // -----------------------------------------------------------------------------
    getDownloadFilesList(showSnackBar: boolean = true) {
        if (this.isLoadingExportList) {
            return;
        }

        this.loading = true;
        this.loadingService.setLoading(this.loading);

        this.isLoadingExportList = true;

        if (this.dbInfoBag === undefined || this.dbInfoBag === null) this.AlertSessionExpired();

        const getExportList = this.importExportService
            .getDownloadList(this.dbInfoBag.AccountName, this.dbInfoBag.SubscriptionKey)
            .subscribe(
                (getResult) => {
                    if (getResult === null || getResult === undefined) {
                        console.log('DatabaseExportDataComponent getExportFilesListResult is null');
                        getExportList.unsubscribe();
                        this.loading = false;
                        this.loadingService.setLoading(this.loading);
                        return;
                    }

                    if (!getResult.Result) {
                        this.noteLevel = QuickNoteLevels.Warn;
                        this.noteTitle = 'Export data';
                        this.noteText = getResult !== null ? getResult.Message : 'An error occurred calling ExportData';
                        getExportList.unsubscribe();
                        this.loading = false;
                        this.loadingService.setLoading(this.loading);
                        return;
                    }

                    const exportList = getResult['Content'] as Array<string>;

                    if (showSnackBar && exportList.length === 0) {
                        this.snackBar.open('No files available for download for this subscription', 'OK', { duration: 5000 });
                    }

                    let rrr: fileDateAndName[] = new Array<fileDateAndName>();
                    for (let index = 0; index < exportList.length; index++) {
                        const element = exportList[index];
                        if (element !== '') {
                          let v = new fileDateAndName();
                          v.fileName = element;
                          v.dateCreat = this.getDateFrom(element);
                          rrr.push(v);
                        }
                    }
                    this.filesT.data = rrr;

                    this.setDatePickerFormat();
                    this.filesT.paginator = this._paginatorFiles;

                    this.loading = false;
                    this.loadingService.setLoading(this.loading);

                    this.isLoadingExportList = false;
                    getExportList.unsubscribe();
                },
                (exportDataError) => {
                    alert(exportDataError);
                    this.loading = false;
                    this.loadingService.setLoading(this.loading);
                    this.isLoadingExportList = false;
                    getExportList.unsubscribe();
                }
            );
    }

    // click sulla riga per eseguire il download
    // --------------------------------------------------------------------------------
    downloadThis(file: fileDateAndName) {
        if (this.dbInfoBag === undefined || this.dbInfoBag === null) this.AlertSessionExpired();
        // richiama l'API per scaricare da REDIS il file zip
        this.importExportService.download(file.fileName, this.dbInfoBag.SubscriptionKey).subscribe(
            (res) => {
                this.downLoadFile(file.fileName, res, 'application/zip');
            },
            (err) => {}
        );
    }

    // --------------------------------------------------------------------------------
    getDateFrom(file: string) {
        let r = file.split('~');

        let d_string = r[1];
        let d_string_split = d_string.split('-');
        let g = d_string_split[0] + '-' + d_string_split[1] + '-' + d_string_split[2];
        let d = new Date(g);
        return d;
    }

    // --------------------------------------------------------------------------------
    setDatePickerFormat() {
        if (this.localSettings) {
            this.adapter.setLocale(this.localSettings);
        } else {
            this.adapter.setLocale(navigator.language);
        }
    }

    // esegue il vero e proprio download del file dentro il browser
    // --------------------------------------------------------------------------------
    downLoadFile(file: string, data: ArrayBuffer, fileType: string) {
        if (data === null || data === undefined) {
            this.snackBar.open('Download not available', 'OK', { duration: 5000 });
            return;
        }

        const newBlob = new Blob([data], { type: fileType });

        // IE compatibility
        let newVariable: any = window.navigator;
        if (newVariable && newVariable.msSaveOrOpenBlob) {
            newVariable.msSaveOrOpenBlob(newBlob);
            return;
        }

        // For other browsers:
        const fileData = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = fileData;
        link.download = file + '.zip';
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

        setTimeout(() => {
            // Firefox fix
            window.URL.revokeObjectURL(fileData);
            link.remove();
            // ricarico i files
            this.getDownloadFilesList(false);
        }, 100);

        // alla fine del download scelgo di NON cancellare il file da REDIS (il ciclo di vita di queste chiavi e' Volatile)
        // capire se va bene cosi oppure se e' meglio eliminarle esplicitamente
        // this.modelService.deleteDownload(this.dbInfoBag.AccountName, this.dbInfoBag.SubscriptionKey, file).subscribe();
    }

    applyFilterSubscriptions(event: any) {
        let filterValue;
        if (event.target) {
            filterValue = (event.target as HTMLInputElement).value;
        } else {
            filterValue = event;
        }
        this.filesT.filter = filterValue.trim().toLowerCase();
        if (this.filesT.paginator) {
            this.filesT.paginator.firstPage();
        }
        if (this.filesT.filteredData.length === 0) {
            this.downloadFound = false;
        } else {
            this.downloadFound = true;
        }
    }

    clearSubscriptionSearch() {
        this.searchText = '';
        this.filesT.filter = this.searchText.trim().toLowerCase();
        this.downloadFound = true;
    }
}
